'use client'
import { Button, Modal } from 'antd';
import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import ModalVideo from 'react-modal-video'
import { Autoplay } from 'swiper/modules';
import { ArrowRightOutlined } from '@ant-design/icons';
export default function VideoPopup({ style }: any) {
    const [isOpen, setOpen] = useState(false)
    const { t } = useTranslation();

    const [videoId, setVideoId] = useState("bCB_YH6qOv8?autoplay=1&mute=1"); 
    const videos = [
        { id: "bCB_YH6qOv8?autoplay=1&mute=1", title: "Video 1" },
        { id: "AirmVuVEKoI?autoplay=1&mute=1", title: "Video 2" },
      ];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

    const openModal = (index: number) => {
        setCurrentVideoIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const nextVideo = () => {
        const currentIndex = videos.findIndex((v) => v.id === videoId);
        const nextIndex = (currentIndex + 1) % videos.length;
        setVideoId(videos[nextIndex].id);
      };
    
      const prevVideo = () => {
        const currentIndex = videos.findIndex((v) => v.id === videoId);
        const prevIndex = (currentIndex - 1 + videos.length) % videos.length;
        setVideoId(videos[prevIndex].id);
      };
    return (
        <>
            {style === 1 &&
                <div className="video-box">
                    <a onClick={() => setOpen(true)} className="video-btn ripple video-popup">
                        <i className="fa-solid fa-play" />
                    </a>
                </div>
            }
            {style === 2 &&
                <div className="video-box">
                    <a onClick={() => setOpen(true)} className="video-buttton video-popup">
                        <i className="fa-solid fa-play" />
                        <img src="/assets/img/about/circle-text.png" alt="text-img" className="text-circle" />
                    </a>
                </div>
            }
            {style === 3 &&
                <span className="button-text wow fadeInUp" data-wow-delay=".9s">
                    <a onClick={() => {
                        setOpen(true)
                        openModal(1)
                    }} className="video-btn ripple video-popup">
                        <i className="fa-solid fa-play" />
                    </a>
                    <span className="ms-4 d-line">{t('WatchInstruction')}</span>
                </span>
            }
            {/* <ModalVideo channel='youtube' isOpen={isOpen} videoId="I6qkrT3VqyA" onClose={() => setOpen(false)} /> */}

            <div style={{ display: isOpen ? "flex" : "none", width: "100%", height: "100vh", position: "fixed", margin: 0, top: 0, left: 0, zIndex: 10 }}>
                <ModalVideo channel='youtube' isOpen={isOpen} videoId={videoId} onClose={() => {
                    setOpen(false);
                    closeModal();
                    setVideoId("bCB_YH6qOv8?autoplay=1&mute=1")
                }} />
                <Button
                    className="theme-btn"
                
                    style={{
                        zIndex: 1000001,
                        margin: "auto 85vw",
                        height: 70,
                    }} onClick={() => {
                        if(videoId === videos[0].id){
                            nextVideo();
                        }else{
                            prevVideo()
                        }
                    }} >
                    <span>
                        {videoId === videos[0].id?
                        <>
                        {t("HowToStart")}
                        <i className="fa-solid fa-arrow-right-long" />
                        </>:
                        <>
                        {t("Previous")}
                        <i className="fa-solid fa-arrow-left-long" />
                        </>}
                        
                    </span>
                </Button>
            </div>
        </>
    )
}